module.exports = __webpack_public_path__ + "media/images/prizes__sidebar--bg-ab6d4c6f9f1f334e2021ddd7f2bf8b04.jpg";